import {
  extractYouTubeVideoId,
  generateYouTubeThumbnail,
  generateYouTubeWatchUrl,
} from './youtubeUtils';

/** Resolve video fields from CMS (supports legacy videoThumbnail + youtube_url only). */
/** Parse encoded markers from public testimonial submission inbox. */
export function parseSubmissionMessage(rawMessage) {
  if (!rawMessage || typeof rawMessage !== 'string') {
    return { courseId: '', youtubeUrl: '', text: '' };
  }

  let remaining = rawMessage;
  let courseId = '';
  const courseMatch = remaining.match(/^\[COURSE:([^\]]+)\]\n?/);
  if (courseMatch) {
    courseId = courseMatch[1];
    remaining = remaining.slice(courseMatch[0].length);
  }

  let youtubeUrl = '';
  const videoMatch = remaining.match(/^\[VIDEO:([^\]]+)\]\n?/);
  if (videoMatch) {
    youtubeUrl = videoMatch[1];
    remaining = remaining.slice(videoMatch[0].length);
  }

  return {
    courseId,
    youtubeUrl,
    text: remaining.trim(),
    type: youtubeUrl ? 'video' : 'text',
  };
}

export function resolveTestimonialVideo(item) {
  if (!item) return null;

  const youtubeId = item.youtube_id || extractYouTubeVideoId(item.youtube_url);
  if (!youtubeId) return null;

  return {
    youtubeId,
    watchUrl: item.youtube_url || generateYouTubeWatchUrl(youtubeId),
    thumbnail:
      item.video_thumbnail ||
      item.videoThumbnail ||
      generateYouTubeThumbnail(youtubeId),
  };
}
